export enum DocumentsColumns {
  Date = 1,
  FileName = 2,
  FileFolder = 3,
  Comment = 4,
}
